<template>
  <div
      :class="[
        'wg-row', 
        'wg-xs-12', 
        !alwaysVisible ? 'wg-md-none' : '', 
        'com-anm22-food-mobile-title-bar' 
      ]"
  >
    <div
      :style="{fontSize: '22px', cursor: order.tableRef ? 'pointer' : 'default'}"
      @click="order.tableRef ? $emit('open-cover-modal') : ''"
    >{{ pageTitle }}</div>
    <div class="wg-md-none com-anm22-food-cart-button" style="width:100px;margin-left:auto;">
      <div
        class="wg-row"
        style="flex-wrap:nowrap;align-items:center;height:100%;justify-content:center;"
        @click="toggleCart"
      >
        <div class="display-flex">
          <div
            v-show="elements > 0"
            class="elements-counter"
          >{{ elements }}</div>
          <img
            :src="$anm22.icons.getWorldIcon('shoppingCart')"
            class="com-anm22-app-img-fixed-height-m"
            style="opacity:0.7;"
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  props: {
    order: Object,
    elements: {
      type: Number,
      default: 0
    },
    alwaysVisible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {};
  },
  computed: {
    ...mapState({
      lang: state => state.lang
    }),
    table() {
      if(this.order.tableRef) {
        return this.$store.getters['foodTables/get'](this.order.tableRef);
      } else {
        return null;
      }
    },
    pageTitle() {
      let tableString = '';
      if(this.order.tableRef) {
        tableString = ' - ';
        if(this.order.tableAlias) {
          tableString += this.order.tableAlias;
        } else {
          tableString += this.$anm22.strLang(this.lang, 'Table', 'Tavolo') + ' ' + this.table.name;
        }
      }
      if(this.order.id && Number.isInteger(this.order.number)) {
        return '#' + this.order.number + tableString;
      } else {
        return this.$anm22.strLang(this.lang, 'New Order', 'Nuovo ordine') + tableString;
      }
    }
  },
  methods: {
    toggleCart() {
      this.$emit('open-cart');
    }
  }
};
</script>

<style lang="scss" scoped>
</style>
